import axios from 'axios';
import { authStorage } from './authStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth interceptor
api.interceptors.request.use((config) => {
  const token = authStorage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authStorage.clearAuth();
      if (window.location.pathname.startsWith('/admin') && 
          window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Public API
export const publicApi = {
  getTours: () => api.get('/tours'),
  getTourBySlug: (slug) => api.get(`/tours/${slug}`),
  getReviews: () => api.get('/reviews'),
  getSettings: () => api.get('/settings'),
  seed: () => api.post('/seed'),
  // Reservations
  createReservation: (data) => api.post('/reservations', data),
  getInvoiceUrl: (reservationId) => `${API_URL}/reservations/${reservationId}/invoice`,
};

// Auth API
export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me'),
};

// Admin API
export const adminApi = {
  // Tours
  getTours: () => api.get('/admin/tours'),
  createTour: (data) => api.post('/admin/tours', data),
  updateTour: (id, data) => api.put(`/admin/tours/${id}`, data),
  deleteTour: (id) => api.delete(`/admin/tours/${id}`),
  
  // Settings
  getSettings: () => api.get('/admin/settings'),
  updateSettings: (data) => api.put('/admin/settings', data),
  
  // Reviews
  getReviews: () => api.get('/reviews'),
  createReview: (data) => api.post('/admin/reviews', data),
  deleteReview: (id) => api.delete(`/admin/reviews/${id}`),
  
  // Media/CMS
  getMedia: (category) => api.get('/admin/media', { params: { category } }),
  uploadMedia: (file, category, alt_text) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category);
    formData.append('alt_text', alt_text);
    return api.post('/admin/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteMedia: (id) => api.delete(`/admin/media/${id}`),
  updateMedia: (id, alt_text, category) => {
    const formData = new FormData();
    formData.append('alt_text', alt_text);
    formData.append('category', category);
    return api.put(`/admin/media/${id}`, formData);
  },
};

export default api;
